import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { amplifyApi } from '../services/amplifyApi';
import { Loader2, ShieldAlert } from 'lucide-react';

function AdminRoute({ children }) {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    async function checkAdmin() {
      if (!isAuthenticated) {
        setChecking(false);
        return;
      }

      const response = await amplifyApi.checkAdminStatus();
      console.log('Admin status check response:', response);
      setIsAdmin(response.isAdmin === true);
      setChecking(false);
    }

    if (!authLoading) {
      checkAdmin();
    }
  }, [isAuthenticated, authLoading]);

  // Still loading auth or checking admin status
  if (authLoading || checking) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-4" />
          <p className="text-slate-600">Checking access...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to home
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Not an admin - show access denied
  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center max-w-md px-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShieldAlert className="w-8 h-8 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Access Denied</h1>
          <p className="text-slate-600 mb-6">
            You don't have permission to access the admin dashboard.
          </p>
          <a
            href="/studio-x7k9m2"
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Return to Studio
          </a>
        </div>
      </div>
    );
  }

  // Is admin - render children
  return children;
}

export default AdminRoute;
